module.exports = __webpack_public_path__ + "website_front_static/img/logo.68c461a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/logo.png
// module id = 1QZ/
// module chunks = 6